import React from 'react';

import CuotaGrupoDetail  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaGrupo/CuotaGrupoDetalle/List.js';

export default function () {
  return <CuotaGrupoDetail  />;
}